import React from 'react'
import WhoHero from '../../Components/who/WhoHero'
import { Briefcase, Share2, Monitor, Factory, RotateCw } from 'lucide-react';
import UserFirstExperienceSection from '../../Components/servicex/UserFirstExperienceSection'
import ServiceX360ViewSection from '../../Components/servicex/ServiceX360ViewSection'
import ServiceXOfferingsSection from '../../Components/servicex/ServiceXOfferingsSection'
import IndustriesServiceExperienceSection from '../../Components/servicex/IndustriesServiceExperienceSection'
import WhatSetsApartSection from '../../Components/servicex/WhatSetsApartSection'
import OtherExpertLedSolutionsSection from '../../Components/servicex/OtherExpertLedSolutionsSection'
import CaseStudySection from '../../Components/servicex/CaseStudySection'
import FAQSection from '../../Components/servicex/FAQSection'
import WhatToExpectSection from '../../Components/servicex/WhatToExpectSection';
import WeCanAlsoHelpWithSection from '../../Components/servicex/WeCanAlsoHelpWithSection';
import { Helmet } from "react-helmet-async";

const serviceItems = [
    {
        id: 1,
        title: "Improve supplier collaboration with unified workflows",
        description: "Streamline communication, onboarding, and lifecycle management across vendor networks with connected, transparent digital workflows.",
        image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 2,
        title: "Reduce procurement cycle time with automation and AI",
        description: "Automate requisition approvals, contract analysis, and order execution to cut cycle times and eliminate manual bottlenecks.",
        image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 3,
        title: "Gain real-time visibility into spend, risk, and performance",
        description: "Track enterprise expenditure, monitor third-party compliance, and benchmark supplier metrics through live, data-driven dashboards.",
        image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1000&q=80"
    }
];
const solutionsData = [
    {
        id: 1,
        title: "ServiceX",
        desc: "Deliver connected service experiences across IT, workplace, customer operations, and field teams to improve engagement and performance.",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: 2,
        title: "Intelligent Operations",
        desc: "Modernize enterprise operations with connected workflows, real-time visibility, and automation that improves service performance and operational efficiency.",
        image: "/assets/mumbai/item9.png",
        link: "#"
    },
    {
        id: 3,
        title: "Risk and Security",
        desc: "Strengthen governance, compliance, and resilience through integrated risk workflows that reduce exposure and protect critical business services.",
        image: "/assets/mumbai/item1.png",
        link: "#"
    }
];

const offeringsData = [
    {
        id: 1,
        title: "Consulting",
        desc: "We assess your current procurement processes, identify inefficiencies, and define a structured roadmap. Our experts align sourcing, procurement, and finance workflows to drive efficiency, compliance, and cost control.",
        products: []
    },
    {
        id: 2,
        title: "Implementation",
        desc: "We deliver structured ServiceNow Source-to-Pay implementations tailored to your enterprise needs. From supplier lifecycle management to purchasing workflows and invoice automation, we ensure seamless deployment and adoption.",
        products: []
    },
    {
        id: 3,
        title: "Support and Maintenance",
        desc: "Post go-live, we provide continuous support, enhancements, and performance optimization. We help you adapt procurement operations as business needs evolve.",
        products: []
    },
    {
        id: 4,
        title: "Resource Augmentation",
        desc: "Scale your team with certified ServiceNow professionals. Whether for short-term initiatives or long-term programs, we provide the right expertise to accelerate delivery.",
        products: []
    }
];


const industryTabs = [
    {
        id: "manufacturing",
        label: "Manufacturing",
        title: "Manufacturing",
        desc: "We help manufacturers drive digital innovation across production, maintenance, and supply chain operations through intelligent automation and AI-powered insights.",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: "bfsi",
        label: "BFSI",
        title: "BFSI",
        desc: "Our innovation frameworks enable financial institutions to modernize operations, enhance customer experiences, and maintain compliance in highly regulated environments.",
        image: "/assets/mumbai/item1.png",
        link: "#"
    },
    {
        id: "retail",
        label: "Retail",
        title: "Retail",
        desc: "Retail organizations leverage our AI-driven innovation capabilities to improve customer engagement, optimize operations, and deliver seamless omnichannel experiences.",
        image: "/assets/mumbai/item5.png",
        link: "#"
    },
    {
        id: "telecom",
        label: "Telecommunication",
        title: "Telecommunication",
        desc: "We help telecom providers innovate across customer service, network operations, and field service through intelligent workflows and scalable digital platforms.",
        image: "/assets/mumbai/item7.png",
        link: "#"
    }
];

const apartData = [
    {
        id: 1,
        title: "120+ ServiceNow Certifications",
        desc: "120+ ServiceNow certifications across procurement, IT, and operations."
    },
    {
        id: 2,
        title: "AI-First Approach",
        desc: "AI-first approach to improve procurement speed, accuracy, and compliance."
    },
    {
        id: 3,
        title: "End-to-End Visibility",
        desc: "End-to-end visibility into spend, supplier performance, and risk."
    },
    {
        id: 4,
        title: "Practitioner-Led Delivery",
        desc: "Practitioner-led delivery focused on measurable business outcomes."
    }
];


const caseStudies = [
    {
        id: 'virgin',
        name: 'Virgin Mobile',
        logoText: 'Virgin Mobile',
        image: '/assets/mumbai/img1.png',
        title: 'Unified IT and Customer Service Operations on ServiceNow for Virgin Mobile UAE',
        desc: 'Reduced service friction, improved operational efficiency, and enhanced customer satisfaction within six months of go-live.',
        link: '#',
        badges: [
            'Deflection in 730 cases',
            'Reduction in agent attrition',
            'Reduction in unfavorable experiences'
        ]
    },
    {
        id: 'ansr',
        name: 'ANSR',
        logoText: 'ANSR',
        image: '/assets/mumbai/img2.png',
        title: 'AI-Enabled Service Operations for ANSR',
        desc: 'Leveraged automation and self-service to reduce manual effort and enhance service delivery across functions.',
        link: '#',
        badges: [
            'Faster Resolution',
            'Improved Employee Satisfaction',
            'Reduced Operational Costs'
        ]
    },
    {
        id: 'entain',
        name: 'Entain',
        logoText: 'Entain',
        image: '/assets/mumbai/img3.png',
        title: 'Enterprise HR Policy Governance Transformation for Entain',
        desc: 'Aligned policy lifecycle with knowledge visibility to ensure consistency, control, and better access management.',
        link: '#',
        badges: [
            'Automated the entire policy lifecycle',
            'Aligned HR policies with governance',
            'Controlled Knowledge Base visibility'
        ]
    },
    {
        id: 'maruti',
        name: 'MARUTI SUZUKI',
        logoText: 'Maruti Suzuki',
        image: '/assets/mumbai/img4.png',
        title: 'Streamlined Dealer Finance & Audit Operations for Maruti Suzuki',
        desc: 'Enabled faster processing, real-time financial insights, and improved compliance across dealer networks.',
        link: '#',
        badges: [
            'Reduced Turnaround Time (TAT)',
            'Enhanced Transparency & Audit Readiness',
            'Instant financial exposure insights'
        ]
    }
];

const faqData = [
    {
        id: 1,
        question: "How does ServiceNow S2P improve procurement efficiency?",
        answer: "ServiceNow S2P streamlines procurement by automating sourcing, purchasing, and invoicing workflows on a single platform. It reduces manual tasks, accelerates approvals, and improves supplier collaboration. With AI-driven insights and standardized processes, enterprises can shorten procurement cycles, minimize errors, and operate with greater speed, consistency, and control."
    },
    {
        id: 2,
        question: "What is the ServiceNow Source to Pay Workspace?",
        answer: "The Source to Pay Workspace provides procurement teams and buyers with a centralized, unified console to manage requisitions, track supplier performance, negotiate cases, and monitor spending analytics in real time."
    },
    {
        id: 3,
        question: "Can ServiceNow S2P integrate with ERP systems like SAP or Oracle?",
        answer: "Yes, ServiceNow S2P integrates natively and seamlessly with major ERP platforms such as SAP, Oracle, and Microsoft Dynamics, orchestrating seamless data flows for purchase orders, master vendor data, and invoice settlements."
    },
    {
        id: 4,
        question: "Is ServiceNow Source to Pay suitable for large enterprises?",
        answer: "Yes, it is purposefully engineered to support complex, multi-entity, and global enterprise operations with distributed spend management, multilingual support, dynamic approval matrices, and scalable cross-regional workflows."
    },
    {
        id: 5,
        question: "How does ServiceNow S2P support compliance and audit readiness?",
        answer: "It enforces standardized policies, automated segregation of duties (SoD), continuous audit trail logging, and seamless alignment with Third-Party Risk Management (TPRM) to keep every purchasing step fully compliant."
    },
    {
        id: 6,
        question: "How does ServiceNow S2P support digital transformation in procurement?",
        answer: "It transforms fragmented, manual purchasing into an intelligent, consumer-grade experience with self-service intake portals, automated vendor lifecycle workflows, and predictive analytics that drive cost optimization."
    }
];

const expectItems = [
    "Supplier Lifecycle Management",
    "Sourcing and Contract Management",
    "Procurement and Purchasing Operations",
    "Invoice Processing and Automation",
    "Spend Visibility and Analytics",
    "Workflow Automation and Approvals",
    "AI-powered Insights and Recommendations",
    "Unified Source-to-Pay Workspace"
];

function SourceToPay() {
    return (
        <div>
            <Helmet>

    {/* Primary SEO */}
    <title>
        ServiceNow Source to Pay (S2P) Implementation | Mobikode
    </title>

    <meta
        name="description"
        content="Mobikode provides ServiceNow Source to Pay implementation and consulting services to automate procurement, supplier management, sourcing, purchasing, invoicing, compliance, and spend visibility with AI-powered workflows."
    />

    <meta
        name="keywords"
        content="ServiceNow Source to Pay, ServiceNow S2P, ServiceNow S2P Implementation, ServiceNow Source to Pay Implementation, ServiceNow Procurement, ServiceNow Procurement Solutions, ServiceNow S2P Consulting, Source to Pay Consulting, Source to Pay Implementation, Procurement Automation, Procurement Digital Transformation, Supplier Management, Supplier Lifecycle Management, Source to Pay Automation, Procurement Workflow Automation, AI Procurement Solutions, ServiceNow Supplier Management, ServiceNow Procurement Consulting, ServiceNow Implementation Partner, ServiceNow S2P Partner"
    />

    {/* Robots */}
    <meta
        name="robots"
        content="index, follow, max-image-preview:large"
    />

    <meta
        name="googlebot"
        content="index, follow"
    />

    {/* Canonical */}
    <link
        rel="canonical"
        href="https://www.mobikode.com/source-to-pay"
    />

    {/* Open Graph */}
    <meta
        property="og:title"
        content="ServiceNow Source to Pay (S2P) Implementation | Mobikode"
    />

    <meta
        property="og:description"
        content="Transform procurement with ServiceNow Source to Pay solutions. Automate sourcing, purchasing, supplier management, invoicing, compliance, and spend visibility."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/source-to-pay"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:site_name"
        content="Mobikode"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/glodesk/bg2.png"
    />

    <meta
        property="og:image:alt"
        content="Mobikode ServiceNow Source to Pay Solutions"
    />

    {/* Twitter */}
    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="ServiceNow Source to Pay (S2P) Implementation | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Automate procurement operations with ServiceNow Source to Pay implementation, consulting, supplier management, and AI-powered workflows."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/glodesk/bg2.png"
    />

    {/* Structured Data */}
    <script type="application/ld+json">
        {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "ServiceNow Source to Pay Implementation",
            "serviceType": "ServiceNow Source to Pay",
            "description":
                "Mobikode provides ServiceNow Source to Pay consulting, implementation, support, and resource augmentation services to help enterprises automate sourcing, procurement, supplier management, purchasing, invoicing, compliance, and spend management.",
            "provider": {
                "@type": "Organization",
                "name": "Mobikode",
                "url": "https://www.mobikode.com/"
            },
            "areaServed": {
                "@type": "Place",
                "name": "Worldwide"
            },
            "hasOfferCatalog": {
                "@type": "OfferCatalog",
                "name": "ServiceNow Source to Pay Services",
                "itemListElement": [
                    {
                        "@type": "OfferCatalog",
                        "name": "ServiceNow Source to Pay Consulting"
                    },
                    {
                        "@type": "OfferCatalog",
                        "name": "ServiceNow Source to Pay Implementation"
                    },
                    {
                        "@type": "OfferCatalog",
                        "name": "ServiceNow S2P Support and Maintenance"
                    },
                    {
                        "@type": "OfferCatalog",
                        "name": "ServiceNow S2P Resource Augmentation"
                    }
                ]
            },
            "url": "https://www.mobikode.com/source-to-pay"
        })}
    </script>

</Helmet>
            <WhoHero
                title="ServiceNow Source to Pay Implementation Partner"
                text="Get AI-powered, proactive, and unified procurement operations/ Accelerate Procurement with Intelligent, End-to-End Automation "
                imgData="/assets/glodesk/bg2.png"
            />
            {/* <UserFirstExperienceSection title="Supercharge enterprises with AI-Driven Innovation" description="Innovation today goes beyond experimenting with new technologies. Organizations need to turn ideas into solutions that improve operations, create better experiences, and drive measurable results. Many enterprises explore AI, automation, and digital tools but struggle to scale them across the business. Mobikode helps organizations move from experimentation to execution. By combining AI capabilities, intelligent automation, and digital engineering, we help enterprises build scalable solutions that improve efficiency, enable faster decisions, and support long-term growth." /> */}
            <ServiceX360ViewSection title="Transform Procurement into a Strategic Advantage with ServiceNow Source to Pay" description="Modern enterprises are shifting procurement from transactional to strategic. ServiceNow Source-to-Pay enables this shift by improving supplier collaboration, enforcing compliance, and driving cost transparency across operations. Aelum enables enterprises to unify sourcing, procurement, and finance operations on a single platform, eliminating silos and manual inefficiencies. From supplier onboarding to invoice processing, we help you digitize the entire procurement lifecycle with automation, AI, and real-time visibility. Whether you are building from the ground up or optimizing existing processes, our experts deliver scalable and tailored S2P solutions." serviceItems={serviceItems} />
            <ServiceXOfferingsSection offeringsData={offeringsData} title="Our ServiceNow Source-to-Pay Services" description="End-to-end support to implement, optimize, and scale procurement operations" />
            <WhatToExpectSection title="What to expect from Automation Engine" description="ServiceNow Source-to-Pay brings together sourcing, procurement, and finance into a unified experience:" expectItems={expectItems} />
            <IndustriesServiceExperienceSection title="Accelerating Innovation Across Industries" industryTabs={industryTabs} />
            <WeCanAlsoHelpWithSection />
            <WhatSetsApartSection title="Why Mobikode for ServiceX? " description="Our deep expertise across experience transformation, workflow design, and enterprise service delivery helps organizations realize faster adoption and measurable outcomes with ServiceX." apartData={apartData} />
            <OtherExpertLedSolutionsSection title="Other Expert-led Solutions" description="   Accelerate enterprise transformation with integrated, intelligent workflows engineered to drive operational resilience and business value." solutionsData={solutionsData} />
            <CaseStudySection title="Real-World Case Studies" description=" See how we help global enterprises drive measurable operational outcomes and unified service delivery." caseStudies={caseStudies} />
            <FAQSection faqData={faqData} />
        </div>
    )
}

export default SourceToPay
